var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "900" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    attrs: { color: "primary", dark: "" },
                    on: { click: _vm.parseProfiling },
                  },
                  on
                ),
                [_vm._v(_vm._s(_vm.$t("campaign_factory.form.manage_url")))]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "text-h5" }, [
            _vm._v(
              _vm._s(_vm.$t("campaign_factory.form.profiling_parameters"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  attrs: { name: "profiling-modal" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.send.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._l(
                    _vm.profilingParameters,
                    function (profilingParameter, profilingParameterIndex) {
                      return _c(
                        "v-row",
                        { key: profilingParameterIndex },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "5", sm: "12", md: "5" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Key" },
                                model: {
                                  value: profilingParameter.key,
                                  callback: function ($$v) {
                                    _vm.$set(profilingParameter, "key", $$v)
                                  },
                                  expression: "profilingParameter.key",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "5", sm: "12", md: "5" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t(
                                    "campaign_factory.form.label.value"
                                  ),
                                },
                                model: {
                                  value: profilingParameter.value,
                                  callback: function ($$v) {
                                    _vm.$set(profilingParameter, "value", $$v)
                                  },
                                  expression: "profilingParameter.value",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "1", sm: "12", md: "1" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-5",
                                  attrs: { small: "", color: "red" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeProfilingParameter(
                                        profilingParameterIndex
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { color: "white" } }, [
                                    _vm._v("mdi-minus"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.addProfilingParameter },
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { attrs: { name: "profiling-modal-action" } },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "grey" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary" },
                  on: { click: _vm.generateProfiling },
                },
                [_vm._v(_vm._s(_vm.$t("actions.valid")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }